import { useCallback } from 'react';
import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

export default function useControlPanelMode() {
  const {
    state: { controlPanelMode },
    dispatch,
  } = useEditSceneModalStateContext();

  const enterAdjustCrop = useCallback(() => {
    dispatch({ type: 'adjust-crop-enter' });
  }, [dispatch]);

  const cancelAdjustCrop = useCallback(() => {
    dispatch({ type: 'adjust-crop-cancel' });
  }, [dispatch]);

  return {
    cancelAdjustCrop,
    enterAdjustCrop,
    controlPanelMode,
  };
}
